import { SubscribedContext } from "@/providers/Subscribed";
import { useArtist } from "@/services/hooks";
import { renderTextWithMentions } from "@/utils/mentions";
import {
  PlayArrow,
  PlayCircle,
  PushPin,
  StarBorder,
  Verified,
  Pause,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@/utils/time";
export default function WelcomeCard({ artistKey }) {
  const navigate = useNavigate();
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);
  const { data: artist } = useArtist(artistKey);
  const [isPlaying, setIsPlaying] = useState(false);
  const message = artist?.meta.previewText || "Welcome to my Notebook!";

  if (!artist) {
    return null;
  }

  if (isSubscribed) {
    return null;
  }

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ ml: 4 }}>
        <PushPin sx={{ color: "darkgray", fontSize: "18px" }} />
        <Typography variant="caption" color="darkgray" sx={{ p: 0, m: 0 }}>
          Pinned
        </Typography>
      </Stack>
      <Box sx={{ display: "flex" }}>
        <Avatar
          src={artist?.meta.profile}
          sx={{ width: 40, height: 40, marginRight: 2, marginTop: 1 }}
          onClick={() => navigate("/" + artistKey)}
        />
        <Box id="post-content-container" style={{ flex: 1 }}>
          <Box
            id="post-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              id="user-detail"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <Typography
                variant="body"
                style={{ marginRight: "5px", fontWeight: "bold" }}
              >
                {artist.name}
              </Typography>
              <Verified
                color={artist.verified ? "secondary" : "disabled"}
                style={{ fontSize: "15px", marginRight: "5px" }}
              />
            </Box>
          </Box>

          <Box id="post-content" style={{ marginTop: "-5px" }}>
            <Box
              style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}
              sx={{ mt: 1, mb: 2 }}
            >
              {renderTextWithMentions(message)}
            </Box>

            <Card style={{ borderRadius: "20px" }}>
              <Box
                style={{
                  overflow: "hidden",
                  borderRadius: "10px",
                  aspectRatio: "1/1",
                }}
                onClick={() => setIsPlaying(!isPlaying)}
              >
                <ReactPlayer
                  url={artist?.meta.preview}
                  light={artist?.meta.profile}
                  playing={isPlaying}
                  width="100%"
                  height="100%"
                />
              </Box>
            </Card>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={() => setIsPlaying(!isPlaying)}>
              {isPlaying ? <Pause /> : <PlayArrow />}
            </IconButton>
            <IconButton onClick={handleModalOpen}>
              <StarBorder />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
